"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ms_rest_js_1 = require("ms-rest-js");
/**
 * Creates a new CognitiveServicesCredentials object.
 *
 * @constructor
 * @param {string} subscriptionKey   The CognitiveServices subscription key
 */
var CognitiveServicesCredentials = /*#__PURE__*/function (_ms_rest_js_1$ApiKeyC) {
  function CognitiveServicesCredentials(subscriptionKey) {
    _classCallCheck(this, CognitiveServicesCredentials);
    if (!subscriptionKey || subscriptionKey && typeof subscriptionKey.valueOf() !== "string") {
      throw new Error("subscriptionKey cannot be null or undefined and must be of type string.");
    }
    var options = {
      inHeader: {
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "X-BingApis-SDK-Client": 'node-SDK'
      }
    };
    return _callSuper(this, CognitiveServicesCredentials, [options]);
  }
  _inherits(CognitiveServicesCredentials, _ms_rest_js_1$ApiKeyC);
  return _createClass(CognitiveServicesCredentials);
}(ms_rest_js_1.ApiKeyCredentials);
exports.CognitiveServicesCredentials = CognitiveServicesCredentials;